export const ImageFileTypes = ['image/jpeg', 'image/gif', 'image/png', 'image/svg+xml']
